export class GrantTransferData {
  receiverFundName: string;
  receiverFundNumber: string;
  amount: string;
  privacy?: string;
  timing: string;
  charityInstruction?: string;
  additionalNotes: string;
  calculatedGrantAssessmentExpense?: number;
  processingAssessmentExpense?: number;
  supplementalGrantAssessment?: number;
  grantAmount?: number;
  charityProjectName?: string;
  isRecurring?: boolean;
  recurrencePattern?: string;
  startDate?: number | null;
  endDate?: number | string | null;

  constructor() {}
}

export class GrantDataFee {
  calculatedGrantAssessmentExpense: number;
  grantAmount: number;
  grantAmountAvailable: number;
  processingAssessmentExpense: number;
  supplementalGrantAssessment: number;

  constructor() {}
}
